export enum NotificationActionType {
  changed = "changed",
  created = "created",
  partialChanged = "partialChanged"
}
